import PageNews from '@/components/PageNews';

export default PageNews;

export async function getStaticProps() {
  return {
    props: {
      path: '/ueber/neuigkeiten',
      theme: 'default',
      description:
        'Pressemeldungen mit Neuigkeiten der Lotterien LOTTO 6aus49, Eurojackpot, KENO und GlücksSpirale und des DLTB',
      title: 'Neuigkeiten - Pressemeldungen',
    },
  };
}
